/** Time to live */
export const TTL = 60000;

export const perProjectRequestCache = new Map<
	string,
	{ value: boolean; timestamp: number } | undefined
>();
